import { Component, OnInit, Input } from '@angular/core';
import { APIService } from 'app/shared/api.service';
import { Api, ApiAction } from 'app/classes/api';
import { Asset } from 'app/classes/asset';

@Component({
    selector: 'app-explorer-api',
    templateUrl: './explorer-api.component.html',
    styleUrls: ['./explorer-api.component.css'],
    standalone: false
})
export class ExplorerApiComponent implements OnInit {

  @Input()
  asset: Asset;

  apis: Map<number, Api>;
  actions: Map<string, ApiAction>;

  action: ApiAction;

  apiSelected: number;
  api: Api;
  pushJSON: string;
  pushAuthorisation: string;
  pushPayload: string;
  isEditingJSON = false;

  isEditingActionJSON = false;
  testResponse: string;

  tabs: any = { selected: 'actions' };

  constructor(private apiService: APIService) {

  }

  ngOnInit() {

    this.init();

  }

  init() {
    this.apiService
      .getAssetAPI(this.asset.id)
      .then(collection => {
        this.apis = new Map();
        collection.apis.forEach(api => {
          this.apis.set(api.id, new Api(api));
        });
        if (collection.apis.length === 1) {
          this.apiSelected = collection.apis[0].id;
          this.apiSelectionChanged();
        }
        this.actions = new Map();
      });
  }

  actionPayloadExample() {
    if (!this.action.payload) {
      const example = `{
}`;
      this.action.payload = example;
    }
  }

  payloadExample() {
    if (!this.api.payload) {
      const example = `{
  "id": $asset_id,
  "ref": $asset_ref,
  "sensor": $asset_type,
  "value": $asset_value,
  "timestamp": $asset_timestamp,
  "datetime": $asset_datetime,
  "action":  $api_action
}`;
      this.api.payload = example;
    }
  }

  updateJSONclick() {
    this.payloadExample();
    this.isEditingJSON = false;
  }

  cancelJSONclick() {
    this.isEditingJSON = false;
  }

  editJSON() {
    this.isEditingJSON = true;
  }

  editActionJSON() {
    // this.actionPayloadExample();
    this.isEditingActionJSON = true;
  }

  cancelActionJSONclick() {
    this.isEditingActionJSON = false;
  }

  updateActionJSONclick() {
    this.actionPayloadExample();
    this.isEditingActionJSON = false;
  }

  newAPIClick() {
    this.apiSelected = 0;
    this.api = new Api();
    this.api.payload = `{
  "id": $asset_id,
  "ref": $asset_ref,
  "sensor": $asset_type,
  "value": $asset_value,
  "timestamp": $asset_timestamp,
  "datetime": $asset_datetime,
  "action":  $api_action
}`;
    this.actions = new Map();
    this.tabs.selected = 'api';
  }

  saveAPIClick() {
    if (this.api.title.trim() === '') {
      return this.apiService.toastWarn('API needs a title', '');
    }
    if (this.api.url.trim() === '') {
      return this.apiService.toastWarn('API needs a URL to POST', '');
    }
    if (this.api.payload.trim() === '') {
      return this.apiService.toastWarn('API needs a payload', '');
    }
    this.apiService
      .patchAssetAPI(this.asset.id, this.api)
      .then(response => {
        console.log(response);
        this.init();
      });
  }

  /**
   * Set the action to request
   * @param action string
   */
  apiActionClick(action) {
    console.log(action);
    this.action = new ApiAction({ action });
    this.actionPayloadExample();
  }

  apiSelectionChanged() {
    console.log('changed');
    this.api = this.apis.get(+this.apiSelected);
  }

  activateAction() {
    this.actions.set(this.action.action, this.action);
  }

  testAction() {
    this.testResponse = null;
    this.apiService
      .apiController('post', 'test', { api: this.api, action: this.action, asset: this.asset })
      .then(response => {
        try {
          this.testResponse = JSON.stringify(JSON.parse(response.Payload), null, 2);
        } catch (e) {
          console.log(e);
        }
      });
  }

}
